import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {
  async updatePlan (plan) {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post('integrations/paddle/update-plan/', { plan: plan })
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  async cancelPlan () {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post('integrations/paddle-billing/cancel/')
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  async pausePlan () {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post('integrations/paddle-billing/pause/')
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  async resumePlan () {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post('integrations/paddle-billing/resume-paused/')
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  async undoPendingChange () {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post('integrations/paddle-billing/undo-pending-change/')
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  async getPaddleManagementLink () {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get('integrations/paddle-billing/management-link/')
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
